import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
export function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-13" data-mp="2spcfb4pc44q2">
      {isVisible && <motion.button initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} onClick={scrollToTop} className="fixed bottom-8 right-8 p-3 bg-cream border border-amber/20 text-charcoal rounded-full shadow-lg hover:border-amber hover:text-amber transition-colors duration-300 z-50" aria-label="Back to top" data-id="element-14" data-mp="2wq62fvuydfhw">
          <ArrowUp size={20} data-id="element-15" data-mp="ugbxsmap75se" />
        </motion.button>}
    </AnimatePresence>;
}